import{createContext as o}from"react";const r=o({});export{r as LayoutGroupContext};
